import React, { FC, useCallback, useEffect, useState, Fragment } from "react";
import { useDrop } from "react-dnd";
import { Card } from "./Card";
import update from "immutability-helper";
import { CaDrugNDropItemType, onDropType } from "../types";

type Props = {
  data: CaDrugNDropItemType[];
  onDrop?: onDropType;
  disabled?: boolean;
  className?: string;
};

export const DndBody: FC<Props> = ({ data, onDrop, disabled, className }) => {
  const [cards, setCards] = useState<CaDrugNDropItemType[]>(data);

  useEffect(() => {
    setCards(data);
  }, [data]);

  const findCard = useCallback(
    (id: string) => {
      const card = cards.filter((item) => `${item.id}` === id)[0];
      return {
        card,
        index: cards.indexOf(card),
      };
    },
    [cards],
  );

  const moveCard = useCallback(
    (id: string, atIndex: number) => {
      const { card, index } = findCard(id);
      setCards(
        update(cards, {
          $splice: [
            [index, 1],
            [atIndex, 0, card],
          ],
        }),
      );
    },
    [findCard, cards, setCards],
  );

  const [, drop] = useDrop(() => ({ accept: "card" }));

  return (
    <div className={className} ref={drop}>
      {cards.map((card, key) => {
        return (
          <Fragment key={card.id}>
            <Card
              keyNumber={key}
              id={`${card.id}`}
              moveCard={moveCard}
              findCard={findCard}
              onDrop={onDrop}
              disabled={disabled}
            >
              {card.children}
            </Card>
          </Fragment>
        );
      })}
    </div>
  );
};

export default DndBody;
